import { useCallback } from 'react'
import { useWeb3React } from '@web3-react/core'
import { useAppDispatch } from 'state'
import { fetchFarmUserDataAsync, updateUserBalance, updateUserPendingReward } from 'state/actions'
import {
  soushHarvest,
  soushHarvestBnb,
  harvest,
  lendingPoolwithdraw,
  lendingPoolwithdrawPxf,
  lendingPoolClaim,
} from 'utils/callHelpers'
import { useFarmFromPid } from 'state/hooks'
import { useLendingPool, usePIXELfarm, usePIXELpool } from './useContract'

export const useHarvest = (farmPid: number) => {
  const dispatch = useAppDispatch()
  const { account } = useWeb3React()
  const farm = useFarmFromPid(farmPid)
  const farmCon = usePIXELfarm(farm.farmAddresses)

  const handleHarvest = useCallback(async () => {
    const txHash = await harvest(farmCon, farmPid, account)
    dispatch(fetchFarmUserDataAsync(account))
    return txHash
  }, [account, dispatch, farmPid, farmCon])

  return { onReward: handleHarvest }
}

export const useSousHarvest = (sousId, isUsingBnb = false) => {
  const dispatch = useAppDispatch()
  const { account } = useWeb3React()
  const sousChefContract = usePIXELpool(sousId)
  const handleHarvest = useCallback(async () => {
    if (isUsingBnb) {
      await soushHarvestBnb(sousChefContract, account)
    } else {
      await soushHarvest(sousChefContract, account)
    }
    dispatch(updateUserPendingReward(sousId, account))
    dispatch(updateUserBalance(sousId, account))
  }, [account, dispatch, isUsingBnb, sousChefContract, sousId])

  return { onReward: handleHarvest }
}

export const useLendingPoolWithdraw = (poolId, slotId) => {
  const { account } = useWeb3React()
  const contract = useLendingPool()
  const handleWithdraw = useCallback(async () => {
    if (slotId !== null) {
      await lendingPoolwithdraw(contract, poolId, slotId, account)
    } else {
      await lendingPoolwithdrawPxf(contract, poolId, account)
    }
  }, [account, contract, poolId, slotId])
  return { onWithdraw: handleWithdraw }
}

export const useLendingPoolClaim = (poolId) => {
  const { account } = useWeb3React()
  const contract = useLendingPool()
  const handleClaim = useCallback(async () => {
    await lendingPoolClaim(contract, poolId, account)
  }, [account, contract, poolId])
  return { onClaim: handleClaim }
}
